import { Tabs, type TabsProps } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import LandingPageMembershipTabContent from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent';
import type { LandingPageMembershipTabData } from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent/LandingPageMembershipTabContentCard';

import defaultMembershipTabs from './_data/defaultLandingPageMemebershipTabData';

export interface LandingPageMembershipTabsProps {
  readonly tabsData?: LandingPageMembershipTabData[] | undefined;
}

const LandingPageMembershipTabs = ({
  tabsData = defaultMembershipTabs,
}: LandingPageMembershipTabsProps) => {
  const t = useTranslations();
  const tabs: TabsProps['tabs'] = tabsData.map(({ Icon, tab }) => ({
    className: 'px-0 py-3',
    icon: <Icon className="mr-2" height="22" width="22" />,
    label: t(tab.label),
  }));
  const tabPanels: TabsProps['tabPanels'] = tabsData.map(
    ({
      backgroundColor,
      Icon,
      id,
      tabPanel,
    }: LandingPageMembershipTabData) => ({
      content: (
        <LandingPageMembershipTabContent
          cards={tabPanel.cards.map((card) => ({ ...card, backgroundColor }))}
          featuredImage={{ ...tabPanel.featuredImage, Icon }}
          key={id}
        />
      ),
    }),
  );
  return (
    <Tabs
      scrollableTablist
      tabList={{
        className: 'gap-x-8 lg:gap-x-10 xl:gap-x-14 xxl:gap-x-20',
      }}
      tabs={tabs}
      tabPanels={tabPanels}
    />
  );
};

export default LandingPageMembershipTabs;
